import { CustomizationStore } from './customizationStore';

export class Lead {
    constructor() {
        this.id = "";
        this.salesAmount = "";
        this.platformId = null;
        this.customization = new CustomizationStore();
        this.causes = new Array<string>();
        this.donationValue = 1;
        this.donationRule = 0;
        this.donationType = 0;
        this.password = "eupolinizo";
    }

    captchaResponse: string;
    id: string;
    name: string;
    email: string;
    domain: string;
    phone: string;
    nameContact: string;
    salesAmount: string;
    platformId: string;
    acquisitionChannel: number;
    platformStoreId: string;
    otherPlatform: string;
    customization: CustomizationStore;
    donationValue: number;
    donationRule: number;
    donationType: number;
    integrationType: number;
    causes: string[];
    password: string;
    howKnow: string;
    extraParms: string
    couponCode: string
    referralCode: string
    document: string
    tempListCauses: string
    businessDescription: string     
    platformSeoName: string
}
